import { Component, OnInit, AfterViewInit, OnDestroy, Renderer2, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { ApiService } from '../l_admin/api.service';
import { AuthService } from '../services/auth.service';
import { Boat } from '../l_admin/boat.model';
import { ToastService } from '../l_admin/toast.service';
import { ToastEvent } from '../l_admin/models/toast-event';
import { Subscription } from 'rxjs';

import { SlickCarouselComponent } from 'ngx-slick-carousel';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import flatpickr from 'flatpickr';
import { Modal } from 'bootstrap';
import { getBoatImageUrl, getPriceImageUrl } from '../utils/image-url.util';


declare var $: any;

@Component({
  selector: 'app-detail-boat',
  templateUrl: './detail-boat.component.html',
  styleUrls: ['./detail-boat.component.css']
})
export class DetailBoatComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('flatpickrEl') flatpickrEl!: ElementRef;
  @ViewChild('datepicker') datepicker!: ElementRef;

  @ViewChild('slickModal') slickModal!: SlickCarouselComponent;
  slickConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    infinite: true,
    adaptiveHeight: true,
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          swipe: true,
          touchThreshold: 10
        }
      }
    ]
  };


  private toastSubscription: Subscription;
  toasts: ToastEvent[] = [];
  isAccordionOpen: boolean[] = [];
  isAccordionServicesOpen: boolean[] = [];
  isLoading = false;
  error: string | null = null;
  link_ktg : string = '';
  link_tampil : string = '';
  param: string | null = null;

  harga_terkecil = '';
  kategori : string | null = null;

  showCarouselModal = false;
  currentCarouselIndex = 0;


  errorMessage: string = '';
  bookForm!: FormGroup;
  submitted = false;
  

  imageSrc: string = '';
  priceModal!: Modal | null;



     constructor(
       private fb: FormBuilder, 
       private router: Router,
       private route: ActivatedRoute,
       private apiService: ApiService,
       private authService: AuthService,
       private toastService: ToastService,
       private renderer: Renderer2,
       private el: ElementRef,
        private cdr: ChangeDetectorRef
       // private ngImageSliderComponent: NgImageSliderComponent
     ) {
       this.toastSubscription = this.toastService.toastEvents.subscribe(
         (event: ToastEvent) => {
           this.toasts = [...this.toasts, event];
           setTimeout(() => {
             this.toasts = this.toasts.filter(t => t !== event);
           }, 3000);
         }
       );
   
       this.isAccordionOpen = this.itineraries.map(() => false); 
       this.isAccordionServicesOpen = this.services.map(() => false); 

       this.initializeForms();
     } 



  private initializeForms() {     
      this.bookForm = this.fb.group({
        destination: ['', [Validators.required]],
        duration: ['', [Validators.required]],
        tamu: ['', [Validators.required]],
        tgl: ['', [Validators.required]],
        total: ['', [Validators.required]]
      });
  }
     
   // Safely get form control with null check
   getFormControl(form: FormGroup, controlName: string): AbstractControl | null {
    return form.get(controlName);
  }
  
  // Safely check if control has specific error
  hasError(form: FormGroup, controlName: string, errorType: string): boolean {
    const control = this.getFormControl(form, controlName);
    return control ? (this.submitted && control.hasError(errorType)) : false;
  }


  get tujuans(): string {
    return this.boat?.ms_tujuans.map(item => item.tuj).join(', ') || '';
  }

  get keterangans(): string {
    return this.boat?.ms_keterangans.map(item => item.ket).join(', ') || '';
  }

  get itineraries(): any[] {
    return this.boat?.ms_itineraries || [];
  }

  get services(): any [] {
    return this.boat?.ms_services || [];
  }

  get harga_private(): any [] {
    return this.boat?.ms_priceprivates|| [];
  }

  get destinations(): any [] {
    return this.boat?.ms_tujuans|| [];
  }
 


  selectedImageIndex = 0;
  boat: Boat | null = null;



  kapalMintour: any[] = [];
  minimumNightMap: { [destination_id: number]: number } = {};


  
loadMinimumNightByKapal() {
  if (this.boat?.ms_tujuans && this.boat?.ms_tujuans.length > 1 && this.boat.id) {
    this.apiService.getMinimumNightByKapal(this.boat.id).subscribe((data: any) => {
      this.kapalMintour = data;

      // Buat map destination_id -> minimum_night
      this.minimumNightMap = {};
      data.forEach((entry : any) => {
        this.minimumNightMap[entry.destination_id] = entry.minimum_night;

      });
    });

    
  }
}


   ngOnInit(): void {
    const slug = this.route.snapshot.paramMap.get('slug');
    if (slug) {
      this.loadBoatDetails(slug);
      // this.loadMinimumNightByKapal();
    
    }  




    setTimeout(() => {
      this.modalDestinasi = new Modal(document.getElementById('destinationModal')!);
    });
   
    setTimeout(() => {
      this.modalDurasi = new Modal(document.getElementById('durationModal')!);
    });

    //Inisialisasi modal Guest
    setTimeout(() => {
      this.modalTamu = new Modal(document.getElementById('guestModal')!);
    });

    //flatpickr Inisialisasi modal Bootstrap
    setTimeout(() => {
      this.modal = new Modal(document.getElementById('dateModal')!);
    });

     
 

   }




  formatHarga(value: number): string {
    return value.toLocaleString('id-ID', { maximumFractionDigits: 0 });
  }

   hargapertama(idKapal: number): void {
    this.apiService.getLowestprice(idKapal).subscribe({
      next: (res) => {
        if (res.success) {
          this.harga_terkecil =  res.data.harga_terkecil;
          this.kategori = res.data.kategori;
        } else {
          console.warn('No data available for this Boat.');
          this.harga_terkecil = 'No price data available.';
          this.kategori = '';
        }
      },
      error: (err) => {
        console.error('Error fetching lowest price:', err);
        this.harga_terkecil = 'Error fetching price.';
        this.kategori = '';
      }
    });
  }


getDestinationIdFromName(tujName: string): number | null {
  const match = this.destinations.find(dest => dest.tuj === tujName);
  return match ? match.id : null;
}



   loadBoatDetails(slug: string): void {
    this.isLoading = true;
    this.apiService.getBoatBySlug(slug).subscribe({
      next: (boatData) => {
        this.boat = boatData.data;
        this.isLoading = false;

        // console.log(this.destinations);

        if (this.boat){


          this.param = this.route.snapshot.queryParamMap.get('destination');


          const kategoriMap: { [key: string]: string } = {
            'Deluxe Boat': 'deluxe-boat',
            'VIP Boat': 'vip-boat',
            'VVIP Boat': 'vvip-boat'
          };


          const tujuanMap: { [key: string]: string } = {
            'alor-island': 'Alor Island',
            'banda-island': 'Banda Island',
            'komodo-national-park': 'Komodo National Park',
            'raja-ampat': 'Raja Ampat',
          };


          if (this.param)
          {
            this.link_ktg = this.param || '';
            this.link_tampil = tujuanMap[this.param] || '';

            const tujuanName = tujuanMap[this.param]; // "Banda Island"
            const tujuanId = this.getDestinationIdFromName(tujuanName) || 1;

            this.pilihTuj(tujuanName,tujuanId);
            //  this.pilihDurasi('2D1N');


             console.log(this.destinations);
          }
          else
          {
            this.link_ktg = kategoriMap[this.boat.boat_kategori] || '';
            this.link_tampil = this.boat.boat_kategori || '';
          }

          const dt_harga = this.harga_private;
          if (dt_harga.length > 0){
           const dataItem = dt_harga[0];

           const durationLabels: { [key: string]: string } = {
            per_hari: 'One Day Trip',
            dua_hari: '2D1N',
            tiga_hari: '3D2N',
            empat_hari: '4D3N',
            lima_hari: '5D4N',
            enam_hari: '6D5N',
            tujuh_hari: '7D6N',
            delapan_hari: '8D7N',
            sembilan_hari: '9D8N',
            sepuluh_hari: '10D9N'
          };


           this.durations = Object.keys(dataItem)
           .filter(key => 
            key in durationLabels && dataItem[key] !== 0 && dataItem[key] !== null
           )
           .map(key => durationLabels[key]);
          } 

          if (this.boat?.ms_gambarkapals?.length) {
            requestAnimationFrame(() => {
              if (this.slickModal && !this.slickModal.initialized) {
                this.slickModal.initSlick();
              } else if (this.slickModal && this.slickModal.initialized) {
                this.slickModal.slickGoTo(0);
                this.currentCarouselIndex = 0;
              }
              this.cdr.detectChanges();
            });
          }


          if (this.boat?.ms_pricedisplays?.length) {
            this.imageSrc = this.boat?.ms_pricedisplays[0].gambar;
          }


         

           if (this.boat?.ms_kapalmintours?.length) {

            // Buat map destination_id -> minimum_night

            this.kapalMintour = this.boat?.ms_kapalmintours;

            this.minimumNightMap = {};
            this.kapalMintour.forEach((entry : any) => {
              this.minimumNightMap[entry.destination_id] = entry.minimum_night;

            });

            // console.log(this.kapalMintour);

          }


      

          // this.hargapertama(this.boat.id);

          // Fetch availability once boat data is loaded
          const now = new Date();
          this.fetchAvailability(now.getMonth() + 1, now.getFullYear());
        }
  

        // this.slickModal.slickGoTo(0); 
      },
      error: (error) => {
        console.error('Error loading boat details', error);
        this.error = 'Failed to load boat details. Please try again later.';
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      complete: () => {
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    });
  }


   ngOnDestroy(): void {
    if (this.toastSubscription) {
      this.toastSubscription.unsubscribe();
    }

    this.renderer.removeClass(document.body, 'modal-open');
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.remove();
    }
    this.renderer.setStyle(document.body, 'padding-right', '');
    this.renderer.removeStyle(document.body, 'overflow');

    this.showCarouselModal = false;
    // this.showGalleryModal = false;

    // this.destroySummernote();

    if (this.slickModal?.initialized) {
      try {
        this.slickModal.unslick();
      } catch (error) {
        console.error('Error cleaning up carousel:', error);
      }
    }

    //flatpickr------------
    if (this.flatpickrInstance) {
      this.flatpickrInstance.destroy();
    }


   }

   getRemainingPhotosCount(): number {
    return this.boat?.ms_gambarkapals ? Math.max(0, this.boat.ms_gambarkapals.length - 3) : 0;
  }


  getRemainingPhotosCountmobile(): number {
    return this.boat?.ms_gambarkapals ? Math.max(0, this.boat.ms_gambarkapals.length - 1) : 0;
  }


   
  openCarouselModal(index: number): void {
    this.showCarouselModal = true;
    document.body.style.overflow = 'hidden';
    
    // Force a change detection cycle to ensure the modal is rendered
    this.cdr.detectChanges();
  
    // Wait for DOM to be ready and modal to be fully shown
    requestAnimationFrame(() => {
      // Additional check to ensure modal is visible
      if (this.showCarouselModal && this.slickModal) {
        // Unslick first if already initialized
        if (this.slickModal.initialized) {
          this.slickModal.unslick();
        }
  
        // Wait for modal transition to complete
        setTimeout(() => {
          if (this.slickModal && this.showCarouselModal) {
            try {
              this.slickModal.initSlick();
              // Go to specific slide after initialization
              setTimeout(() => {
                if (this.slickModal?.initialized) {
                  this.slickModal.slickGoTo(index);
                  this.currentCarouselIndex = index;
                  this.cdr.detectChanges();
                }
              }, 0);
            } catch (error) {
              console.error('Error initializing slick carousel:', error);
            }
          }
        }, 150); // Increased timeout to ensure modal is fully visible
      }
    });
  }

  closeCarouselModal(): void {
    if (this.slickModal?.initialized) {
      try {
        this.slickModal.unslick();
      } catch (error) {
        console.error('Error unslicking carousel:', error);
      }
    }
    
    this.showCarouselModal = false;
    document.body.style.overflow = 'auto';
    this.currentCarouselIndex = 0;
    this.cdr.detectChanges();
  }


//Tujuan----------------------------------------------------------------------
private modalDestinasi!: Modal;

tripDestination: string | null = null; // Durasi yang dipilih
selectedDestination: string = '';

selectedDestinationId: number | null = null;

openModaldestinasi(): void {
  this.modalDestinasi.show();
}

applyDestination(): void {
    if (this.selectedDestination && this.selectedDestinationId !== null) {
    // Simpan ke form jika dibutuhkan:
    this.bookForm.get('destination')?.setValue(this.selectedDestination);

    // Jika kamu mau reset trip duration saat ganti tujuan:
    this.tripDuration = null;
    this.bookForm.get('duration')?.setValue(null);
  }

  this.modalDestinasi.hide();
}



selectDestination(tujuan: string, id: number): void {
  this.selectedDestination =tujuan;
  this.selectedDestinationId = id;
  this.tripDestination =this.selectedDestination;
  this.bookForm.patchValue({ destination : this.tripDestination }); 

  const tamuIntput = document.querySelector('#tamu') as HTMLInputElement;
  if (tamuIntput) {      
      this.value =0;    
      tamuIntput.value = '';
      this.jumTamu='';      
      tamuIntput.dispatchEvent(new Event('input'));
      tamuIntput.dispatchEvent(new Event('change'));
  }
  this.clearSelection();
 
}


//Duration----------------------------------------------------------------------
  private modalDurasi!: Modal;
  durations: string[] = []; // Pilihan durasi
  tripDuration: string | null = null; // Durasi yang dipilih
  selectedDuration: string ='';
  ktg_harga: string | null = null;
  
  selectDuration(duration: string): void {
  // Simpan durasi terpilih
  this.selectedDuration = duration;
  this.tripDuration = duration;

  // Mapping label durasi ke nama field backend dan jumlah hari
  const reverseDurationLabels: Record<string, string> = {
    'One Day Trip': 'per_hari',
    '2D1N': 'dua_hari',
    '3D2N': 'tiga_hari',
    '4D3N': 'empat_hari',
    '5D4N': 'lima_hari',
    '6D5N': 'enam_hari',
    '7D6N': 'tujuh_hari',
    '8D7N': 'delapan_hari',
    '9D8N': 'sembilan_hari',
    '10D9N': 'sepuluh_hari'
  };

  const durationToDays: Record<string, number> = {
    'One Day Trip': 1,
    '2D1N': 2,
    '3D2N': 3,
    '4D3N': 4,
    '5D4N': 5,
    '6D5N': 6,
    '7D6N': 7,
    '8D7N': 8,
    '9D8N': 9,
    '10D9N': 10
  };

  // Ambil nama field backend dan jumlah hari
  const originalDurationKey = reverseDurationLabels[duration] || '';
  const days = durationToDays[duration] || 0;

  // Patch form
  this.bookForm.patchValue({ duration: originalDurationKey });

  // Update harga berdasarkan durasi
  this.ktg_harga = this.kategori_harga(originalDurationKey);

  // Atur batas jumlah tamu berdasarkan durasi
  this.loadMinMaxValues(originalDurationKey);

  // Simpan durasi dalam bentuk angka (untuk fitur lain)
  this.selectionDays = days;

  // Recompute available dates for new duration
  this.clearSelection();
  this.computeAvailableDates();

  // Reset input tamu
  this.resetGuestInput();

  }


  resetGuestInput(): void {
  this.value = 0;
  this.jumTamu = '';

  const tamuInput = document.querySelector('#tamu') as HTMLInputElement;
  if (tamuInput) {
    tamuInput.value = '';
    tamuInput.dispatchEvent(new Event('input'));
    tamuInput.dispatchEvent(new Event('change'));
  }
}


loadMinMaxValues(columnKey: string): void {
  if (!Array.isArray(this.harga_private) || this.harga_private.length === 0) {
    console.warn('harga_private tidak tersedia atau kosong.');
    return;
  }

  // Filter hanya data yang memiliki nilai valid (bukan null/0) pada kolom durasi yang diberikan
  const filteredData = this.harga_private.filter(item => {
    const val = item[columnKey];
    return val !== null && val !== 0;
  });

  if (filteredData.length === 0) {
    console.warn(`Tidak ada data valid untuk durasi '${columnKey}'`);
    this.harga_terkecil = '';
    this.kategori = '';
    this.min=0;
    this.max = 0;
    return;
  }

  // Ambil range jumlah orang dan harga dari data yang valid
  const jumlahOrangList = filteredData.map(item => item.jumlah_orang);
  const hargaList = filteredData.map(item => item[columnKey]);

  this.min = Math.min(...jumlahOrangList);
  this.max = Math.max(...jumlahOrangList);

  this.harga_terkecil = Math.min(...hargaList).toString();

  // Update kategori
  this.kategori = this.kategori_harga(columnKey);
}


kategori_harga(columnKey: string): string {
  if (!Array.isArray(this.harga_private) || this.harga_private.length < 2) {
    return '/group'; // Default fallback
  }

  const validPrices = this.harga_private
    .map(item => item[columnKey])
    .filter(price => price !== null && price !== 0);

  if (validPrices.length < 2) {
    return '/group';
  }

  // Ambil dua harga pertama yang valid
  const [firstPrice, secondPrice] = validPrices;

  return firstPrice === secondPrice ? '/group' : '/group';
}





  
  onTripDurationChange(event: Event): void {
    const selectedValue = (event.target as HTMLSelectElement).value;
    this.tripDuration = selectedValue || null;
  
    // Reset inputs if no duration selected
    if (!this.tripDuration) {
      this.jumTamu = '';
      this.selectedDate = '';
      this.bookForm.patchValue({
        tamu: '',
        tgl: ''
      });
 
    }
  }  




  openModaldurasi(){
    if (!this.tripDestination) { 
      return;
    }
    this.modalDurasi.show();
   }



  mapDurationLabelToField(label: string): string {
    const reverseDurationLabels: Record<string, string> = {
      'One Day Trip': 'per_hari',
      '2D1N': 'dua_hari',
      '3D2N': 'tiga_hari',
      '4D3N': 'empat_hari',
      '5D4N': 'lima_hari',
      '6D5N': 'enam_hari',
      '7D6N': 'tujuh_hari',
      '8D7N': 'delapan_hari',
      '9D8N': 'sembilan_hari',
      '10D9N': 'sepuluh_hari'
    };
    return reverseDurationLabels[label] || '';
  }



   userSelectedDurationMap: { [destinationId: number]: string } = {};

   filteredHargaPrivate: any[] = [];
   //baru
 openDurationModal(destinationId: number): void {
  // Map label durasi ke angka hari
  const durationLabels: { [key: number]: string } = {
    1: 'One Day Trip',
    2: '2D1N',
    3: '3D2N',
    4: '4D3N',
    5: '5D4N',
    6: '6D5N',
    7: '7D6N',
    8: '8D7N',
    9: '9D8N',
    10: '10D9N'
  };

  // Tentukan minimum night dari kapalMintour
  let minNight = 1;
  const matched = this.kapalMintour.find(k => k.destination_id === destinationId);
  if (matched) {
    const parsed = parseInt(matched.minimum_night);
    if (!isNaN(parsed) && parsed >= 1 && parsed <= 10) {
      minNight = parsed;
    }
  }

  // Filter harga_private → hanya data yang memiliki harga > 0 untuk durasi manapun
  this.filteredHargaPrivate = this.harga_private.filter(item => {
    return Object.keys(durationLabels).some(key => {
      const label = durationLabels[+key];
      const durasiField = this.mapDurationLabelToField(label);
      const value = item[durasiField];
      return typeof value === 'number' && value > 0;
    });
  });

  // Buat daftar durasi berdasarkan minimum night dan hanya yang punya harga > 0
  this.durations = [];
  for (let i = minNight; i <= 10; i++) {
    const label = durationLabels[i];
    const field = this.mapDurationLabelToField(label);

    const hasPrice = this.filteredHargaPrivate.some(item => {
      const val = item[field];
      return typeof val === 'number' && val > 0;
    });

    if (label && hasPrice) {
      this.durations.push(label);
    }
  }

  // Simpan ID destinasi yang sedang dipilih
  this.selectedDestinationId = destinationId;

  // Isi selectedDuration dengan data sebelumnya jika sudah ada
  this.selectedDuration = this.userSelectedDurationMap[destinationId] || '';

  // Tampilkan modal
  this.modalDurasi.show();
}



   //


  applyDuration() {
    if (!this.tripDuration) { 
      return;
    }


     if (this.selectedDestinationId && this.selectedDuration) {
       this.userSelectedDurationMap[this.selectedDestinationId] = this.selectedDuration;
     }

    this.modalDurasi.hide();
    
  }

//-------------------------------------------------



  closeGuestModal(): void {
    this.modalTamu.hide();
  }

  openGuestModal(): void {
    if (!this.tripDuration) { 
      return;
    }
  
      this.modalTamu.show();
  
    
  }


  private modalTamu!: Modal;
  value: number = 0; // Nilai default
  min: number = 0; // Batas minimal
  max: number = 0; // Batas maksimal
  jumTamu : string = '';


  loadPrice(): void {
    if (!this.harga_private || this.harga_private.length === 0) {
      // console.warn('Harga private tidak tersedia.');
      return;
    }
  
    // Cari data harga berdasarkan jumlah orang
    const hargaData = this.harga_private.find(item => item.jumlah_orang === this.value);
  
    if (!hargaData) {
      // console.warn(`Tidak ditemukan harga untuk ${this.value} orang.`);
      this.perHari = 0; // Atur harga ke 0 jika tidak ditemukan
      return;
    }
  
    // Pastikan durasi telah dipilih
    if (!this.selectedDuration) {
      // console.warn('Durasi belum dipilih.');
      this.perHari = 0;
      return;
    }
  
    // Ambil harga berdasarkan durasi yang dipilih
    this.perHari = hargaData[this.selectedDuration] || 0; // Default ke 0 jika harga tidak ditemukan
    // console.log(`Harga untuk ${this.value} orang (${this.selectedDuration}): ${this.perHari}`);
  }
  


  increment(): void {
    if (this.value < this.max) {
      this.value++;
    }
   
    const tamuIntput = document.querySelector('#tamu') as HTMLInputElement;
    if (tamuIntput) {    
      if (this.value  > 0)
        {      
          tamuIntput.value = this.value.toString();   
          this.jumTamu =  this.value + " Person";
        }
        else
        {
          tamuIntput.value = '';
          this.jumTamu='';
        }
        tamuIntput.dispatchEvent(new Event('input'));
        tamuIntput.dispatchEvent(new Event('change'));

     
    }
    this.clearSelection();
       // Perbarui harga di kalender dan total harga
      this.updateDayPrices();
      // this.calculateTotalPrice();
  }

  decrement(): void {
    if (this.value > this.min) {
      this.value--;
    }
    this.jumTamu =  this.value + " Person";
    const tamuIntput = document.querySelector('#tamu') as HTMLInputElement;
    if (tamuIntput) {    
      if (this.value  > 0)
        {      
          tamuIntput.value = this.value.toString();   
          this.jumTamu =  this.value + " Person";
        }
        else
        {
          tamuIntput.value = '';
          this.jumTamu='';
        }
        tamuIntput.dispatchEvent(new Event('input'));
        tamuIntput.dispatchEvent(new Event('change'));

    }
    this.clearSelection();
     // Perbarui harga di kalender dan total harga
    this.updateDayPrices();
    // this.calculateTotalPrice();
  }

  validateValue(): void {
    if (this.value < this.min) {
      this.value = this.min;
    } else if (this.value > this.max) {
      this.value = this.max;
    }
  }
  isDecrementDisabled(): boolean {
    return this.value <= this.min;
  }
  
  isIncrementDisabled(): boolean {
    return this.value >= this.max;
  }

  openModaltamu(){
    if (!this.tripDuration) { 
      return;
    }
    this.modalTamu.show();
  }

  applyTamu(){
    if (this.value === 0) {
      return;
    }

    this.modalTamu.hide();
  }



 //flatpickr
 private modal!: Modal;
 flatpickrInstance: any;
 selectedDate: string = '';
 tempSelectedDate: string = '';
 totalPrice: string = '';
 tampilTotal:string | null = null;
 formattedDate: string = '';


 selectionDays: number = 0;

 // --- Calendar availability ---
 availableSchedules: any[] = [];
 availableDateSet: Set<string> = new Set();
 private allAvailableDatesSet: Set<string> = new Set();
 private closedDatesSet: Set<string> = new Set();
 isLoadingAvailability: boolean = false;
 private availabilityRequestId: number = 0;

 perHari: number = 0;



 //--------------------

//flatpickr
private getTomorrow(): string {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  const day = String(tomorrow.getDate()).padStart(2, '0');
  const month = String(tomorrow.getMonth() + 1).padStart(2, '0'); // Bulan dimulai dari 0
  const year = tomorrow.getFullYear();

  return `${day}-${month}-${year}`; // Format "dd-mm-yyyy"
}

private fetchAvailability(month: number, year: number): void {
  if (!this.boat?.id) return;

  const requestId = ++this.availabilityRequestId;
  this.isLoadingAvailability = true;

  const months: { month: number; year: number }[] = [];
  for (let offset = -1; offset <= 1; offset++) {
    let m = month + offset;
    let y = year;
    if (m < 1) { m = 12; y--; }
    if (m > 12) { m = 1; y++; }
    months.push({ month: m, year: y });
  }

  const boatIds = [this.boat.id];
  let completedRequests = 0;
  let allSchedules: any[] = [];

  months.forEach(({ month: m, year: y }) => {
    this.apiService.getScheduleStatuses(boatIds, m, y).subscribe({
      next: (response: any) => {
        if (requestId !== this.availabilityRequestId) return;
        if (response.success && response.data) {
          allSchedules = allSchedules.concat(response.data);
        }
        completedRequests++;
        if (completedRequests === months.length) {
          const seen = new Set<string>();
          this.availableSchedules = allSchedules.filter((s: any) => {
            if (seen.has(s.schedule_hash)) return false;
            seen.add(s.schedule_hash);
            return true;
          });
          this.computeAvailableDates();
          this.isLoadingAvailability = false;
        }
      },
      error: (err: any) => {
        console.error('[fetchAvailability]', err);
        if (requestId !== this.availabilityRequestId) return;
        completedRequests++;
        if (completedRequests === months.length) {
          this.computeAvailableDates();
          this.isLoadingAvailability = false;
        }
      }
    });
  });
}

private computeAvailableDates(): void {
  this.availableDateSet.clear();
  this.allAvailableDatesSet.clear();
  this.closedDatesSet.clear();

  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(0, 0, 0, 0);

  const days = this.selectionDays || 1;

  // --- PASS 1: Collect ALL individually available AND closed dates ---
  this.availableSchedules.forEach((schedule: any) => {
    const from = new Date(schedule.date_from + 'T00:00:00');
    const to = new Date(schedule.date_to + 'T00:00:00');

    const current = new Date(from);
    while (current <= to) {
      if (current >= tomorrow) {
        const key = `${current.getFullYear()}-${String(current.getMonth()+1).padStart(2,'0')}-${String(current.getDate()).padStart(2,'0')}`;
        if (schedule.status === 'available') {
          this.allAvailableDatesSet.add(key);
        } else if (schedule.status === 'closed') {
          this.closedDatesSet.add(key);
        }
      }
      current.setDate(current.getDate() + 1);
    }
  });

  // --- PASS 2: Determine valid START dates ---
  // A date is a valid start date only if all `days` consecutive dates
  // (starting from that date) are present in allAvailableDatesSet.
  this.allAvailableDatesSet.forEach((dateKey) => {
    const [y, m, d] = dateKey.split('-').map(Number);
    const startDate = new Date(y, m - 1, d);

    let allConsecutiveAvailable = true;
    for (let i = 0; i < days; i++) {
      const checkDate = new Date(startDate);
      checkDate.setDate(startDate.getDate() + i);
      const checkKey = `${checkDate.getFullYear()}-${String(checkDate.getMonth()+1).padStart(2,'0')}-${String(checkDate.getDate()).padStart(2,'0')}`;
      if (!this.allAvailableDatesSet.has(checkKey)) {
        allConsecutiveAvailable = false;
        break;
      }
    }

    if (allConsecutiveAvailable) {
      this.availableDateSet.add(dateKey);
    }
  });

  // Redraw flatpickr to re-trigger onDayCreate with updated availability
  if (this.flatpickrInstance) {
    this.flatpickrInstance.redraw();
  }
}

private initFlatpickr() {
  this.flatpickrInstance = flatpickr(this.flatpickrEl.nativeElement, {
    dateFormat: 'd/m/Y',
    inline: true,
    static: true,
    defaultDate: this.selectedDate || undefined,
    appendTo: this.flatpickrEl.nativeElement.parentElement,
    minDate: this.getTomorrow(),
    maxDate: "31-12-2027",
    enableTime: false,
    showMonths: 1,
    prevArrow: '<svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M7 16l-4-4m0 0l4-4m-4 4h18"></path></svg>',
    nextArrow: '<svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3"></path></svg>',
    onChange: (selectedDates) => {
      if (!selectedDates.length || this.flatpickrInstance.config.preventRecursion) return;

      this.flatpickrInstance.config.preventRecursion = true;
      
      const startDate = selectedDates[0];
      const tempDates = Array.from({length: this.selectionDays}, (_, i) => {
        const date = new Date(startDate);
        date.setDate(startDate.getDate() + i);
        return date;
      });

      // Validate all consecutive dates are available
      const allValid = tempDates.every((date) => {
        const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        return this.allAvailableDatesSet.has(key);
      });

      if (!allValid) {
        this.flatpickrInstance.clear();
        this.selectedDate = '';
        this.flatpickrInstance.config.preventRecursion = false;
        return;
      }

      this.flatpickrInstance.setDate(tempDates, false);

      // Set the selected date
      this.selectedDate = selectedDates[0].toLocaleDateString('id-ID'); // Format it to display as string


      this.updateFooter(tempDates);
      this.updateDayPrices();
      
      this.flatpickrInstance.config.preventRecursion = false;

    },
    onDayCreate: (datesArr, dateStr, instance, dayElem) => {
      const dayNum = parseInt(dayElem.innerText, 10);
      const month = instance.currentMonth;
      const year = instance.currentYear;

      const date = new Date(year, month, dayNum);
      const dayIndex = date.getDay();

      const price = this.getPriceForDay(dayIndex) || 0;

      dayElem.innerHTML = `
      <span class="dayNum">${dayNum}</span>
      <span class="dayPrice">${this.formatUang(price)}</span>
      `;

      // Check schedule availability — style dates based on status
      const dateKey = `${year}-${String(month + 1).padStart(2, '0')}-${String(dayNum).padStart(2, '0')}`;
      if (this.closedDatesSet.has(dateKey)) {
        // Booked/closed dates — distinct color to indicate booking exists
        dayElem.classList.add('flatpickr-day-booked');
        dayElem.classList.add('notAllowed');
        dayElem.classList.remove('flatpickr-day-secondary');
      } else if (!this.availableDateSet.has(dateKey)) {
        // No schedule or not a valid start date — gray out
        dayElem.classList.add('flatpickr-day-secondary');
        dayElem.classList.add('notAllowed');
        dayElem.classList.remove('flatpickr-day-booked');
      } else {
        // Available — normal styling
        dayElem.classList.remove('flatpickr-day-secondary');
        dayElem.classList.remove('flatpickr-day-booked');
        dayElem.classList.remove('notAllowed');
      }
    },
    onReady: () => {
      const monthInput = document.querySelector('select.flatpickr-monthDropdown-months') as HTMLInputElement;
      const yearInput = document.querySelector('.numInput.cur-year') as HTMLInputElement;
      
      if (monthInput) monthInput.disabled = true;
      if (yearInput) {
        yearInput.disabled = true;
        document.querySelector('span.arrowUp')?.setAttribute('style', 'display: none');
        document.querySelector('span.arrowDown')?.setAttribute('style', 'display: none');
      }

      // Fetch availability for the initial month
      const now = new Date();
      this.fetchAvailability(now.getMonth() + 1, now.getFullYear());
    },
      // Event yang dipanggil ketika bulan diubah
      onMonthChange: (selectedDates, dateStr, instance) => {
        this.updateDayPrices();
        this.fetchAvailability(instance.currentMonth + 1, instance.currentYear);
      },

      // Event yang dipanggil ketika tahun diubah
      onYearChange: (selectedDates, dateStr, instance) => {
        this.updateDayPrices();
        this.fetchAvailability(instance.currentMonth + 1, instance.currentYear);
      },
  
  });

  this.flatpickrInstance.config.preventRecursion = false;
}

private updateDayPrices() {

  if (!this.flatpickrInstance) return;


  const dayElements = document.querySelectorAll('span.flatpickr-day');
  const selectedDates = this.flatpickrInstance.selectedDates;
  const sortedSelectedDates = [...selectedDates].sort((a, b) => a.getTime() - b.getTime());

  dayElements.forEach((dayElem: any) => {
    const ariaLabel = dayElem.getAttribute('aria-label');

    if (!ariaLabel) return;

    const dayDateObj = new Date(ariaLabel);
    const isSelected = sortedSelectedDates.some(date => 
      date.toDateString() === dayDateObj.toDateString()
    );
    
    const isFirstDate = sortedSelectedDates.length > 0 && 
      sortedSelectedDates[0].toDateString() === dayDateObj.toDateString();

    const dayNum = dayElem.innerHTML;

    // Hitung harga untuk hari tersebut
    const dayIndex = parseInt(dayNum, 10) - 1; // Hari pertama = 0
    const price = this.getPriceForDay(dayIndex);

    const priceElem = dayElem.querySelector('.dayPrice');
    if (priceElem) {
      if (isSelected && !isFirstDate) {
        priceElem.style.display = 'none'; // Sembunyikan elemen
    } else {
        priceElem.style.display = ''; // Tampilkan elemen kembali (gunakan default CSS)
        priceElem.textContent = this.formatUang(price); // Atur konten harga
    }
    }
  });

}


private calculateTotalPrice(): void {
  if (!this.selectedDate || !this.harga_private || this.selectionDays === 0) {
    this.totalPrice = this.formatUang(0);
    return;
  }

  // Cari harga berdasarkan jumlah orang
  const hargaData = this.harga_private.find(item => item.jumlah_orang === this.value);
  if (!hargaData) {
    this.totalPrice = this.formatUang(0);
    return;
  }

  // Ambil harga berdasarkan durasi
  const durationKeys: string[] = ['per_hari', 'dua_hari', 'tiga_hari', 'empat_hari', 'lima_hari', 'enam_hari', 'tujuh_hari', 'delapan_hari', 'sembilan_hari', 'sepuluh_hari'];
  const selectedKey = durationKeys[this.selectionDays - 1];

  const totalPrice = selectedKey ? hargaData[selectedKey] : 0;
  this.totalPrice = this.formatUang(totalPrice);
}

private getPriceForDay(dayIndex: number): number {
  if (!this.harga_private || this.harga_private.length === 0) {
    return 0;
  }

  // Cari data harga berdasarkan jumlah orang
  const hargaData = this.harga_private.find(item => item.jumlah_orang === this.value);
  if (!hargaData) {
    return 0;
  }

  // Ambil harga berdasarkan durasi
  const durationKeys: string[] = ['per_hari', 'dua_hari', 'tiga_hari', 'empat_hari', 'lima_hari', 'enam_hari', 'tujuh_hari', 'delapan_hari', 'sembilan_hari', 'sepuluh_hari'];
  const selectedKey = durationKeys[this.selectionDays - 1];
  return hargaData[selectedKey] || 0;
}

private updateFooter(selectedDates: Date[]) {
  if (selectedDates.length === 0) return;

  const startDate = selectedDates[0];
  const endDate = new Date(startDate);
  endDate.setDate(startDate.getDate() + (this.selectionDays - 1));

  const options: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric' };
  this.formattedDate = `${startDate.toLocaleDateString('en-GB', options)} - ${endDate.toLocaleDateString('en-GB', options)}`;

  // Hitung total harga berdasarkan jumlah orang dan durasi
  const hargaPerDurasi = this.getHargaByDuration(this.value);
  // const totalHarga = hargaPerDurasi * this.value; // `this.value` adalah jumlah orang
  const totalHarga = hargaPerDurasi;
  this.totalPrice = totalHarga.toString(); // Format harga sesuai kebutuhan
  this.tampilTotal = totalHarga.toString();

  const totalInput = document.querySelector('#total') as HTMLInputElement;
  if (totalInput) {    
    if (totalHarga  > 0)
      {      
        totalInput.value = totalHarga.toString();   
      }
      else
      {
        totalInput.value = '';
      }
      totalInput.dispatchEvent(new Event('input'));
      totalInput.dispatchEvent(new Event('change'));  
  }



  const tglInput = document.querySelector('#tgl') as HTMLInputElement;
  if (tglInput) {
    const opt: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric', year: 'numeric' };
    this.selectedDate = selectedDates[0].toLocaleDateString('en-GB', opt);
    const startDateString = this.formatDateToYMD(startDate);
    const endDateString = this.formatDateToYMD(endDate);
    tglInput.value = `${startDateString} - ${endDateString}`;

    tglInput.dispatchEvent(new Event('input'));
    tglInput.dispatchEvent(new Event('change'));
  }
}

// Fungsi tambahan untuk mendapatkan harga berdasarkan durasi
private getHargaByDuration(jum : number): number {
  const durationsMapping: { [key: string]: string } = {
    'One Day Trip': 'per_hari',
    '2D1N': 'dua_hari',
    '3D2N': 'tiga_hari',
    '4D3N': 'empat_hari',
    '5D4N': 'lima_hari',
    '6D5N': 'enam_hari',
    '7D6N': 'tujuh_hari',
    '8D7N': 'delapan_hari',
    '9D8N': 'sembilan_hari',
    '10D9N': 'sepuluh_hari',
};

  const durationKey = durationsMapping[this.selectedDuration];
  if (!durationKey) {
    console.warn('Durasi tidak valid:', this.selectedDuration);
    return 0;
  }

  const data = this.harga_private.find(
    (item: any) => item.jumlah_orang === jum
  );

  if (!data) {
    console.warn('Jumlah orang tidak ditemukan:', jum);
    return 0;
  }

  const harga = data[durationKey] ?? 0;
  return harga;
}

 //flatpickr 
ngAfterViewInit(): void {
   setTimeout(() => {
    this.initFlatpickr();
    this.updateDayPrices();
    // this.calculateTotalPrice();
   }, 10);

   const modalElement = document.getElementById('priceModal');
   if (modalElement) {
     this.priceModal = new Modal(modalElement);
   }

}

pilihTuj(tujuan: string, id_tujuan : number): void {
  this.selectedDestination =tujuan;
  this.selectedDestinationId = id_tujuan;
  this.tripDestination =this.selectedDestination;
  this.bookForm.patchValue({ destination : this.tripDestination }); 
}

pilihDurasi(duration:string):void{
  this.selectedDuration = duration; // Set pilihan durasi
  this.tripDuration = this.selectedDuration;

  const reverseDurationLabels: { [key: string]: string } = {
    'One Day Trip': 'per_hari',
    '2D1N': 'dua_hari',
    '3D2N': 'tiga_hari',
    '4D3N': 'empat_hari',
    '5D4N': 'lima_hari',
    '6D5N': 'enam_hari',
    '7D6N': 'tujuh_hari',
    '8D7N': 'delapan_hari',
    '9D8N': 'sembilan_hari',
    '10D9N': 'sepuluh_hari'
  };


  const durationToDays: { [key: string]: number } = {
    'One Day Trip': 1,
    '2D1N': 2,
    '3D2N': 3,
    '4D3N': 4,
    '5D4N': 5,
    '6D5N': 6,
    '7D6N': 7,
    '8D7N': 8,
    '9D8N': 9,
    '10D9N': 10
  };

   // Cari nama asli kolom berdasarkan durasi yang dipilih
  const originalDurationKey = reverseDurationLabels[duration];
  

  this.bookForm.patchValue({ duration : originalDurationKey }); // Perbarui nilai form
 
  this.ktg_harga = this.kategori_harga(originalDurationKey);
  this.loadMinMaxValues(originalDurationKey);
  this.selectionDays = durationToDays[duration] || 0;

  // Recompute available dates for new duration
  this.clearSelection();
  this.computeAvailableDates();

  // const tamuIntput = document.querySelector('#tamu') as HTMLInputElement;
  // if (tamuIntput) {      
  //     this.value =0;    
  //     tamuIntput.value = '';
  //     this.jumTamu='';      
  //     tamuIntput.dispatchEvent(new Event('input'));
  //     tamuIntput.dispatchEvent(new Event('change'));
  // }
}





openModal() {

  if (!this.tripDuration) { 
    return;
  }
  
  if (this.value === 0) {
    return;
  }


  // Show the modal
  this.modal.show();
  
}

 applyDate() {
    // Check if a date is selected
    const selectedDates = this.flatpickrInstance.selectedDates;
    if (selectedDates.length === 0) {
      return;
    }
    this.modal.hide();
 }
 


formatDateToYMD(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Bulan dimulai dari 0
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
//--------------------------


  formatUang(amount: number): string {
    // Menggunakan format singkatan M untuk juta, B untuk milyar
    if (amount >= 1_000_000_000) {
      // Miliyar
      return `IDR ${ (amount / 1_000_000_000).toFixed(0) }B`;
    } else if (amount >= 1_000_000) {
      // Juta
      return `IDR ${ (amount / 1_000_000).toFixed(0) }M`;
    } else if (amount >= 1_000) {
      // Ribu
      return `IDR ${ (amount / 1_000).toFixed(0) }K`;
    } else {
      // Nilai di bawah seribu (biasa)
      return `IDR ${ amount.toString() }`;
    }
  }

  clearSelection() {
   
    this.flatpickrInstance.selectedDates = null;
    this.selectedDate = '';
    this.formattedDate = '';
    this.totalPrice = '';
    this.tampilTotal = null;
   const tglInput = document.querySelector('#tgl') as HTMLInputElement;
   if (tglInput) {
      tglInput.value = '';
      tglInput.dispatchEvent(new Event('input'));
      tglInput.dispatchEvent(new Event('change'));
   }
    this.flatpickrInstance.clear();  // Clear the date selection in flatpickr

   

  }


  pesan(): void {
    this.submitted = true;

    if (this.bookForm.valid) {
        this.isLoading = true;

        const boatData = {
            id_kapal : this.boat?.id,
            nama_kapal: this.boat?.nama_kapal,
            gambar_kapal: this.boat?.ms_gambarkapals[0] || 'No image available', // Item pertama dari ms_gambarkapals
            boat_kategori: this.boat?.boat_kategori,
            trip_kategori: this.boat?.trip_kategori
        };

        const bookingData = {
            destination: this.bookForm.value.destination,
            duration: this.bookForm.value.duration,
            guests: this.bookForm.value.tamu,
            startDate: this.bookForm.value.tgl,
            total: this.bookForm.value.total,
            ...boatData,
        };

        // Format booking data
        const formattedData = this.formatBookingData(bookingData);

        // Simpan data terformat ke localStorage




        localStorage.setItem('formattedBookingData', JSON.stringify(formattedData));

        this.authService.checkLocalStorage();

        // Navigasi ke halaman checkout dengan data terformat
        this.router.navigate(['/checkout'], { state: { bookingData: formattedData } });

        this.submitted = false;
        this.isLoading = false;
    }
  }

  formatBookingData(data: any): any {
    // Mapping untuk durasi
    const durationMapping: { [key: string]: string } = {
      per_hari: 'One Day Trip',
      dua_hari: '2D1N',
      tiga_hari: '3D2N',
      empat_hari: '4D3N',
      lima_hari: '5D4N',
      enam_hari: '6D5N',
      tujuh_hari: '7D6N',
      delapan_hari: '8D7N',
      sembilan_hari: '9D8N',
      sepuluh_hari: '10D9N',
    };
  
    // Format nilai booking
    const formattedDuration = durationMapping[data.duration] || data.duration;
    const formattedGuests = `${data.guests} x Persons`;
  
    // Format tanggal
    const formattedStartDate = data.startDate
      .split(' - ')
      .map((date: any) => {
        const parsedDate = new Date(date.trim());
        return parsedDate.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
      })
      .join(' - ');
  
    // Format total
    // const formattedTotal = `IDR ${Number(data.total).toLocaleString('id-ID')}`;
  
    return {
      destination : data.destination,
      duration: formattedDuration,
      guests: formattedGuests,
      startDate: formattedStartDate,
      total: data.total,
      id_kapal : data.id_kapal,
      nama_kapal : data.nama_kapal,
      gambar_kapal: data.gambar_kapal,
      boat_kategori: data.boat_kategori,
      trip_kategori: data.trip_kategori
    };
  }


  onSlideChange(event: any): void {
    this.currentCarouselIndex = event.currentSlide;
    this.cdr.detectChanges();
  }


 // Prevent paste of non-numeric values
 preventPaste(event: any): void {
  event.preventDefault();
}

// Prevent keypress for non-numeric characters
preventKeypress(event: any): void {
  const pattern = /[0-9]/; // Only allow digits
  if (!pattern.test(event.key)) {
    event.preventDefault();
  }
}


openModalPrice () :void {
  if (this.priceModal) {
    this.priceModal.show();
  }
}

getImageUrl(path: string): string {
  return getBoatImageUrl(path);
}

getPriceUrl(path: string): string {
  return getPriceImageUrl(path);
}

}
